export const CALENDAR_TYPE = {
  EVERY: 1, // a cada
  TIMES_PER: 2, // vezes por
  PER_SHIFT: 3 // por turno
};
